import React, { useState, useEffect } from "react";
import "../result/result.css";

const SubjectWiseResult = () => {
    const [academicYear, setAcademicYear] = useState("");
    const [classValue, setClassValue] = useState("");
    const [subject, setSubject] = useState("");
    const [selectedExamName, setSelectedExamName] = useState("");
    const [studentData, setStudentData] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [marksData, setMarksData] = useState({});
    const [classes, setClasses] = useState([]);
    const [subjects, setSubjects] = useState({});
     const [division, setDivision] = useState("");
              const [divisions, setDivisions] = useState([]);
    const examNames = ["First Semester", "Second Semester"];
    const examNameTranslations = {
        "First Semester": "प्रथम सत्र",
        "Second Semester": "द्वितीय सत्र",
      };

    const udiseNumber = localStorage.getItem("udiseNumber");
  
    useEffect(() => {
        if (udiseNumber) {
            fetchStudentData();
        }
    }, [udiseNumber]);

    useEffect(() => {
        if (subject && selectedExamName && classValue && academicYear) {
            fetchMarksForSelectedSubject();
        }
    }, [subject, selectedExamName, classValue, academicYear]);
    
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

    useEffect(() => {
      const storedLanguage = localStorage.getItem('language') || 'English';
      setLanguage(storedLanguage);
    }, []);

    const handleAcademicYearChange = (e) => setAcademicYear(e.target.value);
 
    const handleSubjectChange = (e) => setSubject(e.target.value);
    const handleExamNameChange = (e) => setSelectedExamName(e.target.value);
useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`);
        if (response.ok) {
          const data = await response.json();
          
          if (data) {
            setAcademicYear(data.defaultYear || ""); 
          }
        } else {
          console.error("Failed to fetch default settings.");
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
      }
    };
  
    fetchDefaultSettings();
  }, [udiseNumber]);


    


  // IndexedDB constants
  const DB_NAME = 'SchoolManagementDB';
  const STUDENT_STORE = 'studentData';
  const DB_VERSION = 1;
  const SCHOOL_STORE = 'schoolData'; // Add this with your other constants

const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => {
      console.error("IndexedDB error:", event.target.error);
      reject(event.target.error);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      if (!db) {
        console.error("Error: db object is not initialized");
        reject("Error: db object is not initialized");
      } else {
        resolve(db);
      }
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

      // Create object stores if they don't exist
      if (!db.objectStoreNames.contains(STUDENT_STORE)) {
        db.createObjectStore(STUDENT_STORE, { keyPath: "id" });
      }
      if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
        db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
      }
    };
  });
};

  // Function to fetch student data from IndexedDB
  const fetchStudentData = async () => {
    try {
      
      const db = await openDB();
      if (!db) {
        console.error("Error: db object is not initialized");
        return;
        
      }

      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll();

      request.onsuccess = (event) => {
        const students = event.target.result;

          const activeStudents = students.filter(student => 
          student.isActive !== false
        );


        const filteredStudents = activeStudents.filter((student) => student.division === division);

        setStudentData(filteredStudents);

        const classesAndDivisions = {};
        activeStudents.forEach((student) => {
          if (student && student.currentClass) {
            if (!classesAndDivisions[student.currentClass]) {
              classesAndDivisions[student.currentClass] = {};
            }

            const division = student.division || "";
            if (!classesAndDivisions[student.currentClass][division]) {
              classesAndDivisions[student.currentClass][division] = [];
            }

            classesAndDivisions[student.currentClass][division].push(student.id);
          }
        });

        // Extract class, division, and srNo from key
        const updatedStudents = activeStudents.map((student) => {
          const keyParts = student.id.split("-"); // Split by "-"
          const className = keyParts[0]; // First part is class
          const division = keyParts[1]; // Second part is division
          const srNo = keyParts[keyParts.length - 1]; // Last part is srNo
          return { ...student, className, division, srNo };
        });

        setClasses(Object.keys(classesAndDivisions));
        setStudentData(updatedStudents); // Store updated students
      };

      request.onerror = (event) => {
        console.error("Error fetching student data from IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };



  const fetchDivisionsForClass = async (classValue) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll(); // Fetch all students

      request.onsuccess = (event) => {
        const students = event.target.result;
        const divisionsForClass = new Set();

        students.forEach((student) => {
          if (student.currentClass === classValue) {
            divisionsForClass.add(student.division);
          }
        });

        setDivisions(Array.from(divisionsForClass)); // Update divisions state
      };

      request.onerror = (event) => {
        console.error("Error fetching divisions from IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error opening IndexedDB:", error);
    }
  };

  const handleClassChange = async (e) => {
    const selectedClass = e.target.value;
    setClassValue(selectedClass); // Update the class value
    setDivision(""); // Reset division when class changes
    fetchSubjectsForClass(e.target.value);
  
    if (selectedClass) {
      await fetchDivisionsForClass(selectedClass);
    }
  
    // Filter students based on the selected class
    const filteredStudents = studentData.filter((student) => student.currentClass === selectedClass);
    setSelectedStudents(filteredStudents);
  };

  
  const handleDivisionChange = (e) => {
    const selectedDivision = e.target.value;
    setDivision(selectedDivision); // Update division state
  
    // Filter students based on the selected class and division
    const filteredStudents = studentData.filter((student) => student.currentClass === classValue && student.division === selectedDivision);
    setSelectedStudents(filteredStudents);
  };

    const fetchSubjectsForClass = async (classValue) => {
      try {
        if (!academicYear) {
          console.error("Academic year is not set");
          return;
        }
  
        // Construct the new URL for fetching subjects
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/${academicYear}/${classValue}.json`;
  
        // Fetch subjects directly from the `subjectSequence` node
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch subjects for class ${classValue}`);
        }
  
        const subjectsData = await response.json();
        if (subjectsData) {
          // Filter out null values and convert to array of valid subjects
          const validSubjects = Object.entries(subjectsData)
            .filter(([_, value]) => value !== null && value !== undefined)
            .sort(([a], [b]) => parseInt(a) - parseInt(b))
            .map(([_, subject]) => subject);
  
          // Convert array to object with sequential numbering
          const formattedSubjects = validSubjects.reduce((acc, subject) => {
            acc[subject] = true;
            return acc;
          }, {});
  
          setSubjects(formattedSubjects); // Update state with the formatted subjects
          setSubject(Object.keys(formattedSubjects)[0] || ""); // Set the first subject as selected
        } else {
          console.warn("No subjects found for the specified class and academic year");
          setSubjects({});
        }
      } catch (error) {
        console.error(
          `Error fetching subjects for class ${classValue} and academic year ${academicYear}:`,
          error
        );
      }
    };
    
    

    const fetchMarksForSelectedSubject = async () => {
      try {
        const selectedStudents = studentData.filter(
          (student) => student.currentClass === classValue && student.division === division
        );
        setSelectedStudents(selectedStudents);
  
        // Use Promise.all to fetch marks concurrently
        const marksDataPromises = selectedStudents.map((student) =>
          fetchMarksData(student.srNo, academicYear, selectedExamName, subject)
        );
        // Wait for all fetches to complete
        const marksDataArray = await Promise.all(marksDataPromises);
        // Map the results back to the student SR numbers
        const marksData = {};
        selectedStudents.forEach((student, index) => {
          marksData[student.srNo] = marksDataArray[index];
        });
        setMarksData(marksData);
      } catch (error) {
        console.error("Error fetching marks data:", error);
      }
    };

    const fetchMarksData = async (srNo, academicYear, examName, subject) => {
      try {
        const db = await openDB();
        const transaction = db.transaction(STUDENT_STORE, "readonly");
        const store = transaction.objectStore(STUDENT_STORE);
        const request = store.get(`${classValue}-${division}-${srNo}`);
        return new Promise((resolve) => {
          request.onsuccess = (event) => {
            const studentData = event.target.result;
            if (
              studentData &&
              studentData.result &&
              studentData.result[academicYear] &&
              studentData.result[academicYear][examName] &&
              studentData.result[academicYear][examName][subject]
            ) {
              const marks = studentData.result[academicYear][examName][subject];
              resolve(marks);
            } else {
              resolve({});
            }
          };
          request.onerror = () => {
            console.error("Error fetching marks data:");
            resolve({});
          };
        });
      } catch (error) {
        console.error("Error fetching marks data:", error);
        return {};
      }
    };

    const [schoolData, setSchoolData] = useState(null); 
   const fetchSchoolData = async () => {
  try {
    const db = await openDB();
    const transaction = db.transaction(SCHOOL_STORE, "readonly");
    const store = transaction.objectStore(SCHOOL_STORE);
    const udise = localStorage.getItem("udiseNumber");
    const request = store.get(udise);

    return new Promise((resolve) => {
      request.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {
          console.log("School data from IndexedDB:", data);
          setSchoolData(data);
          resolve(data);
        } else {
          console.log("No school data found in IndexedDB, fetching from Firebase");
        }
      };

      request.onerror = (event) => {
        console.error("Error fetching school data from IndexedDB:", event.target.error);
      };
    });
  } catch (error) {
    console.error("Error accessing IndexedDB:", error);
  }
};

          useEffect(() => {
            fetchSchoolData(); 
          }, []); 



    const handlePrint = () => {
        const tableElement = document.getElementById("printableTable");
        if (tableElement) {
          const tableContent = tableElement.outerHTML;
      
          const schoolName = schoolData?.schoolName || "";
          const schoolLogo = schoolData?.schoolLogo || ""; // Placeholder if no logo is available
      
          const printWindow = window.open("", "", "height=600,width=800");
          printWindow.document.write("<html><head><title>Print</title>");
      
          // Include your styles here
          printWindow.document.write(`
            <style>
           @page {
                size: A4 Landscape; 
              margin: 3mm;
            }
                table {
                    width: 100%;
                    border-collapse: collapse;
                }
                th, td {
                    border: 1px solid #ccc;
                    padding: 5px;
                    text-align: left;
                    width: calc(100% / 7); /* Adjust width to fit the number of columns */
                }
                thead th {
                    background-color: #f4f4f4;
                    font-weight: normal; /* Removes bold styling */
                }
                tbody td {
                    text-align: center;
                    font-weight: normal; /* Removes bold styling */
                }
                .grade-table table {
                    width: 100%;
                    border-collapse: collapse;
                }
                .grade-table th, .grade-table td {
                    border: 1px solid #ccc;
                    padding: 5px;
                    text-align: center;
                    width: calc(100% / 10); /* Adjust based on the number of columns */
                }
                .grade-table thead th {
                    background-color: #f4f4f4;
                }
                .grade-table tbody td {
                    text-align: center;
                }


                

                  .school-header {
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  margin-bottom: 20px;
                  padding: 10px;
                  border: 1px solid #ccc; /* Add border to the header */
                }
                .school-header img {
                  max-height: 70px; /* Adjust as needed */
                  margin-right: 15px; /* Spacing between logo and school name */
                }
                .school-header h1 {
                  font-size: 24px; /* Increased font size for school name */
                  margin: 0;
                  text-align: left; /* Align text to the left */
                  flex: 1; /* Take up remaining space */
                  text-overflow: ellipsis; /* Add ellipsis if text overflows */
                  white-space: nowrap; /* Prevent text from wrapping to next line */
                }
                  th, td{
                  text-align:center;
                  }
                .school-header h1.multi-line {
                  text-align: center; /* Center text if it wraps to next line */
                  white-space: normal; /* Allow text to wrap to next line */
                }
                .school-header-container {
                  margin-bottom: 20px;
                }
            </style>
        `);
        printWindow.document.write("</head><body>");
          
        // Add school header with increased text size and logo to the left
        const img = printWindow.document.createElement("img");
        img.src = schoolLogo;
        img.alt = "School Logo";
    
        img.onload = function() {
          printWindow.document.write(`
            <div class="school-header-container">
              <div class="school-header">
                <img src="${schoolLogo}" alt="School Logo">
                <h1 class="${schoolName.length > 30 ? 'multi-line' : ''}">${schoolName}</h1>
                <p>${language === "English" ? 'Subject':'विषय'} : ${subject}
                <br/>
                ${language === "English" ? 'Class':'वर्ग'} : ${classValue}
                 <br/>
                  ${language==="English"?'Division': 'तुकडी'} : ${division || '-'}</p>
              </div>
            </div>
          `);
    
          // Add the table content
          printWindow.document.write(tableContent);
    
          printWindow.document.write("</body></html>");
          printWindow.document.close();
          printWindow.print();
        };
    
        img.onerror = function() {
          // If the logo fails to load, proceed without the logo
          printWindow.document.write(`
            <div class="school-header-container">
              <div class="school-header">
                <h1 class="${schoolName.length > 30 ? 'multi-line' : ''}">${schoolName}</h1>
                <p>Class: ${classValue}</p>
              </div>
            </div>
          `);
    
          // Add the table content
          printWindow.document.write(tableContent);
    
          printWindow.document.write("</body></html>");
          printWindow.document.close();
          printWindow.print();
        };
      } else {
        console.error("Table element with ID 'printableTable' not found.");
      }
    };
    
    return (
        <div>
            {/* <Sidebar /> */}
            <div className="p-3 main-content-of-page">
            <h3 style={{color:'rgb(3, 54, 94)'}} className="title"> {language === "English" ? "Subject Wise" : "विषय निहाय निकाल"}</h3>

                <table className="table table-striped table-bordered">
                    <tbody>
                        <tr>
                            <th>{language === "English" ? "Academic Year " : "शैक्षणिक वर्ष"}</th>
                            <td>
                                <select
                                    id="academicYear"
                                    value={academicYear}
                                    onChange={handleAcademicYearChange}
                                    className="form-control custom-select"
                                >
                                  <option >{language === "English" ? "Select Year " : "वर्ष निवडा"}</option>
                                    <option value="2023-2024">2023-2024</option>
                                    <option value="2024-2025">2024-2025</option>
                                    <option value="2025-2026">2025-2026</option>
                                    <option value="2026-2027">2026-2027</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>{language === "English" ? "Class" : "वर्ग"}</th>
                            <td>
                                <select
                                    id="class"
                                    value={classValue}
                                    onChange={handleClassChange}
                                    className="form-control custom-select"
                                >
                                <option value="">{language === "English" ? "Select Class" : "वर्ग निवडा"}</option>
                                    {classes.map((cls, index) => (
                                        <option key={index} value={cls}>
                                            {cls}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                  <th>{language === "English" ? "Division" : "तुकडी"}</th>
                  <td>
                    <select value={division} onChange={handleDivisionChange} className="form-control custom-select">
                      <option value="">{language === "English" ? "Select Division" : "तुकडी निवडा"}</option>
                      {divisions.map((div) => (
                        <option key={div} value={div}>
                          {div}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
                        <tr>
                            <th>{language === "English" ? "Subject" : "विषय"}</th>
                            <td>
                                <select
                                    id="subject"
                                    value={subject}
                                    onChange={handleSubjectChange}
                                    className="form-control custom-select"
                                >
                                  <option value="">{language === "English" ? "Select Subject" : "विषय निवडा"}</option>
                                    {Object.keys(subjects).map((sub, index) => (
                                        <option key={index} value={sub}>
                                            {sub}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>{language === "English" ? "Exam Name" : "परीक्षेचे नाव"}</th>
                            <td>
                                <select
                                    id="examName"
                                    value={selectedExamName}
                                    onChange={handleExamNameChange}
                                    className="form-control custom-select"
                                >
                                <option value="">{language === "English" ? "Select Exam" : "परीक्षा निवडा"}</option>
                                    {examNames.map((examName, index) => (
                                        <option key={index} value={examName}>
                                            {language === "English" ? examName : examNameTranslations[examName]}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                            <button onClick={handlePrint} className="btn btn-primary">
                    {language === "English" ? "Print" : "Print करा"}
                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
               
                <br/>






                <div className="table-responsive">
    <table className="table table-striped table-bordered grdTable" id="printableTable">
        <thead>
            <tr>
                <th>{language === "English" ? "Roll No" : "हजेरी नं"}</th>
                <th>{language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव"}</th>
                <th colSpan="9" className="text-center">{language === "English" ? "Akarik" : "आकारिक"}</th>
                <th colSpan="4" className="text-center">{language === "English" ? "Sanklit" : "संकलित"}</th>
            </tr>
            <tr >
                <th colSpan="2" className="text-center" ></th>
                <th style={{fontWeight: 'normal',fontSize:'14px'}}>{language === "English" ? "Activity" : "उपक्रम/कृती"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Daily Monitoring" : "दैनंदिन निरीक्षण"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Demonstration" : "प्रात्यक्षिके"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Homework" : "गृहपाठ"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Oral Work" : "तोंडी काम"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Others" : "इतर"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Project" : "प्रकल्प"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Test" : "चाचणी"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Total" : "एकूण"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Orally" : "तोंडी"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Demonstration" : "प्रात्यक्षिके"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Writing" : "लेखन"}</th>
                <th style={{fontWeight:'normal',fontSize:'14px'}}>{language === "English" ? "Total" : "एकूण"}</th>
            </tr>
        </thead>
       <tbody>
          {[...selectedStudents]
            .sort((a, b) => a.rollNo - b.rollNo)
            .map((student) => (
              <tr key={student.srNo}>
                            <td>{student.rollNo}</td>
                            <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
                            <td>{marksData[student.srNo]?.Akarik?.Activity ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Akarik?.['Daily Monitoring'] ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Akarik?.Demonstration ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Akarik?.Homework ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Akarik?.['Oral Work'] ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Akarik?.Others ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Akarik?.Project ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Akarik?.Test ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Akarik?.Total ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Sanklik?.Orally ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Sanklik?.Demonstration ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Sanklik?.Writing ?? '-'}</td>
                            <td>{marksData[student.srNo]?.Sanklik?.Total ?? '-'}</td>
                        </tr>
            ))}
        </tbody>
      </table>
</div>


<style jsx>
              {
              `
                .grdTable td, .grdTable th{
                  width:auto;
                }
              `
              }
            </style>


            </div>
        </div>
    );
};

export default SubjectWiseResult;